import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Enumroles } from '@app/models/enumroles.enum';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
claims$ = new BehaviorSubject(null);
claimslist: string[] = [];

constructor() { }

setClaims(claims: any) {
  this.claims$.next(claims);
}

setClaimsInLocalStorage(claims: string) {
  localStorage.setItem('claims', claims);
}

getClaimsFromLocalStorage() {
  return localStorage.getItem('claims');
}

getListOfClaims() {
  this.claimslist = [];
  this.claims$.getValue().claimsList.forEach(element => {
    this.claimslist.push(element.key);
  });
  return this.claimslist;
}

getActualMemberId() {
  return this.claims$.getValue()?.id;
}

getLodgeIdForLodgeAdministrator() {
  const idx = this.claims$.getValue().claimsList.findIndex(item => {
    return item.key === 'of-member_administrator-lodge';
  });

  return idx !== -1 ? this.claims$.getValue().claimsList[idx].value.id : false;
}



isAdminForInstitution(institutionid: number) {

  const idn: number[] = [];
  this.claims$.getValue().claimsList.forEach(element => {
    if ((element.key).indexOf('administrator') !== -1) {
      if (element.value) {
      idn.push(element.value.id);
      }
    }
  });

  let hit = false;
  idn.forEach(data => {
    if (Number(data) === Number(institutionid)) {
      hit = true;
    }
  });
  return hit;
}

isClerk() {
  while (!this.claims$) {
 
 const idx = this.claims$.getValue().claimsList.findIndex(item => {
    // return item.key === 'of-member_clerk';
    return item.key === Enumroles.CLERK;
  });

  return idx !== -1 ? true : false;
 }
}

isUser() {
  const idx = this.claims$.getValue().claimsList.findIndex(item => {
    // tslint:disable-next-line:max-line-length
    return item.key === Enumroles.CLERK || item.key === Enumroles.ADMIN_CAMP || item.key === Enumroles.ADMIN_LODGE || item.key === Enumroles.SYSTEM_ADMIN;
  });
  return idx !== -1 ? false : true;
}

isSomekindofAdmin() {
   while (!this.claims$) {
  const idx = this.claims$.getValue().claimsList.findIndex(item => {
    // tslint:disable-next-line:max-line-length
    return item.key === Enumroles.ADMIN_LODGE || item.key === Enumroles.ADMIN_CAMP || item.key === Enumroles.SYSTEM_ADMIN || item.key === Enumroles.CLERK;
  });
  return idx !== -1 ? true : false;
}
}

isSysAdmin() {
  while (!this.claims$) {
  const idx = this.claims$.getValue().claimsList.findIndex(item => {
    // return item.key === 'of-member_clerk';
    return item.key === Enumroles.SYSTEM_ADMIN;
  });

  return idx !== -1 ? true : false;
}
}

isFinancialOfficerCamp() {
   while (!this.claims$) {
  const idx = this.claims$.getValue().claimsList.findIndex(item => {
    return item.key === Enumroles.FINANCIAL_OFFICER_CAMP;
  });

  return idx !== -1 ? true : false;
}
}

}
